<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">
                <navbar1 />
                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        <navbar2 />
                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background:
                                    #fff;">
                                        <div class="page-body">
                                            <h4 class="ml-2 pb-4">Opening</h4>
                                            <div class="row">
                                                <div class="col-lg-9 col-xl-9 col-md-12">
                                                    <!-- Job description card start -->
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <h5>{{opening.jobrole.name}}</h5>
                                                            <span class="f-14 m-b-10">Created At:
                                                                {{opening.created_at.split(" ")[0]}}</span>
                                                        </div>
                                                        <div class="card-block">
                                                            <h4 class="sub-title">Job Description</h4>
                                                            <div v-html="opening.jobdescription"></div>

                                                            <div class="social-share mt-5">
                                                                <a v-if="$checkPerm('socialmedia.create')" target="_blank"
                                                                    v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+ shareURI +'&src=sdkpreparse'"
                                                                    class="fb-xfbml-parse-ignore btn btn-facebook btn-md">
                                                                    <i class="icofont icofont-social-facebook"></i>
                                                                    Share to Facebook
                                                                </a>&nbsp;
                                                                <a v-if="$checkPerm('socialmedia.create')" target="_blank"
                                                                    v-bind:href="'https://www.linkedin.com/sharing/share-offsite/?url='+ shareURI"
                                                                    class="btn btn-linkedin btn-md">
                                                                    <i class="icofont icofont-brand-linkedin"></i>
                                                                    Share to LinkedIn
                                                                </a>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <!-- Job description card end -->
                                                </div>

                                                <div class="col-md-12 col-xl-3 col-lg-3">

                                                    <div class="card widget-statstic-card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Total Applications</h5>
                                                            </div>
                                                        </div>
                                                        <div class="card-block">
                                                            <i class="icofont icofont-paper st-icon bg-c-blue"></i>

                                                            <div class="text-left">
                                                                <h3 class="d-inline-block">{{opening.applicants_count}}</h3>
                                                                <!-- <i class="icofont icofont-long-arrow-up f-30 text-c-green"></i> -->
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <!-- <div class="card widget-statstic-card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Recruitments</h5>
                                                            </div>
                                                        </div>
                                                        <div class="card-block">
                                                            <i class="icofont icofont-paper st-icon bg-c-orenge"></i>

                                                            <div class="text-left">
                                                                <h3 class="d-inline-block">5,456</h3>
                                                            </div>
                                                        </div>
                                                    </div> -->

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .btn-dribbble i,
    .btn-dropbox i,
    .btn-facebook i,
    .btn-flickr i,
    .btn-github i,
    .btn-google-plus i,
    .btn-instagram i,
    .btn-linkedin i,
    .btn-pinterest i,
    .btn-skype i,
    .btn-tumblr i,
    .btn-twitter i,
    .btn-youtube i {
        margin: 0 !important;
        padding: 0px !important;
    }
</style>

<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'
    export default {
        name: 'Opening',
        data() {
            return {
                opening: {
                    created_at: "",
                    applicants: "",
                    role_name: "",
                    jobdescription: "",
                    jobrole: {}
                },
                id: ''
            }
        },

        components: {
            navbar1,
            navbar2
        },

        mounted() {

            var loading_html = '<div style="height:150px;width:150px;margin: 0 auto;"><img style="width: 100%;" src="https://i.ya-webdesign.com/images/minimalist-transparent-loading-gif-6.gif" /></div>'

            this.$swal.fire({
                title: "<h5></h5>",
                html: loading_html,
                showConfirmButton: false,
                showCancelButton: false,
                allowOutsideClick: false
            })

            let id = this.$route.params.id
            this.id = this.$route.params.id
            this.getOpening(id)
        },
        methods: {
            getOpening: function (id) {

                var get_openings_request = {
                    what: 'viewOpening',
                    id: id
                }
                let vm = this;
                this.$socket.makeGetRequest(get_openings_request)
                    .then((response) => {
                        // if (response.type == 'viewOpening') {
                            this.$swal.close()
                            console.log(response.data)
                            vm.opening  = response.data
                            // let opening_count = data.length
                            // for (var i = 0; i < opening_count; i++) {
                            //     if (data[i].id == id) {
                            //         this.opening = data[i]
                            //         break
                            //     }
                            // }

                        // }
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            }
        },
        computed: {
            shareURI: function () {
                return encodeURI('https://wajesmarthrms.website/application/' + this.id)
            }
        }
    }
</script>